module.exports = __webpack_public_path__ + "static/media/wxTotast.5d288778.png";